import { CanteenCartItemInput } from '../MenuCart/types'
import { numberFormat } from '@/helpers/numbers'

export type CartMappingOptionInput = {
  item: {
    id: string
    price: number
    name: string
  }
  category: {
    id: string
  }
}

type CartMappingItemInput = {
  liveMenuItem: {
    _id: string
    name: string | null
    image: string | null
    variations: Array<{
      _id: string
      type: string | null
      priceCustomerFacing: number | null
      varType: string | null
    }> | null
  }
  submenuId: string
  vendorLocationId: string
}

export const graphqlDataToCartItem = (
  gqlItem: CartMappingItemInput,
  itemData: { quantity: number; ccVariationId: string },
  optionData: CartMappingOptionInput[],
  liveVariationQuantityData: {
    orderLimit: number | null;
    quantityRemaining: number | null;
  }
): CanteenCartItemInput => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const { liveMenuItem, submenuId, vendorLocationId } = gqlItem
  if (!liveMenuItem) throw new Error('Invalid item, no item')
  const { variations } = liveMenuItem
  const ccVariation = variations?.find((variation) => variation._id === itemData.ccVariationId)
  if (!ccVariation) throw new Error('Invalid item, no ccVariation')
  // eslint-disable-next-line react-hooks/rules-of-hooks
  return {
    name: liveMenuItem.name || '',
    supplierLocationId: Number(vendorLocationId),
    id: liveMenuItem._id,
    itemId: ccVariation._id,
    submenuId: Number(submenuId),
    qty: itemData.quantity,
    quantityRemaining: liveVariationQuantityData.quantityRemaining ?? null,
    orderLimit: liveVariationQuantityData.orderLimit ?? null,
    item: {
      name: liveMenuItem.name || '',
      image: liveMenuItem.image || '',
      price: numberFormat((ccVariation.priceCustomerFacing || 0) / 100, 2),
      type: ccVariation.type || '',
    },
    options: optionData.map((option) => {
      return {
        id: option.item.id,
        name: option.item.name,
        price: numberFormat((option.item.price || 0) / 100, 2),
        option: {
          id: option.category.id,
        },
      }
    }),
  }
}
